import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1];
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-foreground-900 font-bold text-lg font-heading">
              <span className="text-primary-500">CSSBuy</span>
              <span>Spreadsheet</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footer.disclaimer')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground-800 mb-4 text-sm uppercase tracking-wider">
              {t('footer.links')}
            </h3>
            <ul className="space-y-2">
              <li><a href={`/${currentLang}/articles/cssbuy-spreadsheet-guide`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">CSSBuy Spreadsheet Guide</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('cta.cssbuySpreadsheet')}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('cta.buyNow')}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-foreground-800 mb-4 text-sm uppercase tracking-wider">
              {t('footer.legal')}
            </h3>
            <ul className="space-y-2">
              <li><span className="text-sm text-foreground-600">{t('footer.privacy')}</span></li>
              <li><span className="text-sm text-foreground-600">{t('footer.terms')}</span></li>
              <li><span className="text-sm text-foreground-600">{t('footer.editorial')}</span></li>
              <li><span className="text-sm text-foreground-600">{t('footer.sitemap')}</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-200 mt-10 pt-6 text-center">
          <p className="text-xs text-foreground-500">
            {t('footer.copyright').replace('{year}', String(year))}
          </p>
        </div>
      </div>
    </footer>
  );
}